import { render, staticRenderFns } from "./rzewm.vue?vue&type=template&id=077fbf15&scoped=true"
import script from "./rzewm.vue?vue&type=script&lang=js"
export * from "./rzewm.vue?vue&type=script&lang=js"
import style0 from "./rzewm.vue?vue&type=style&index=0&id=077fbf15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fbf15",
  null
  
)

export default component.exports